import { StrapiCoverDescriptionColor } from '@src/types/strapi'

export const colorDescription: Record<StrapiCoverDescriptionColor, string> = {
  blue: 'blue.500',
  orange: 'orange-500',
  black: 'black',
  white: 'white',
}
